<template>
  <div>
    <treeselect
      v-bind="propsToPass"
      :options="internalOptions"
      :value="value"
      @input="onInput"
      @search-change="onSearchChange"
      :clear-on-select="false"
      :loading="isLoading"
    />
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";

export default {
  name: "TreeselectExtended",
  components: {
    Treeselect
  },
  props: {
    value: {
      type: null,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Select..."
    },
    "no-results-text": {
      type: String,
      default: "No results found... Press enter to add"
    },
    searchFunc: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      searchQuery: "",
      lastSearchQuery: "",
      isLoading: false,
      internalOptions: []
    };
  },
  watch: {
    options: {
      handler(newValue) {
        this.internalOptions = newValue;
      },
      immediate: true
    }
  },
  computed: {
    propsToPass() {
      const props = { ...this.$props };
      delete props.value;
      delete props.options;
      delete props.searchFunc;
      return props;
    }
  },
  methods: {
    onInput(value) {
      if (value === 'new' && this.searchQuery) {
        this.createNewOption();
      } else {
        this.$emit("input", value);
      }
    },
    async onSearchChange(searchQuery) {
      this.searchQuery = searchQuery;
      
      if (this.searchFunc && searchQuery && searchQuery.trim() !== "") {
        try {
          this.isLoading = true;
          const results = await this.searchFunc(searchQuery);
          this.internalOptions = results;
        } catch (error) {
          console.error('Search error:', error);
        } finally {
          this.isLoading = false;
        }
      }
      
      this.lastSearchQuery = searchQuery;
    },
    createNewOption() {
      if (!this.searchQuery || this.searchQuery.trim() === "") return;

      const newId = Date.now();

      this.$emit("new-node", { 
        value: this.searchQuery, 
        id: newId 
      });

      this.searchQuery = "";
    }
  },
};
</script>

<style scoped>
::v-deep .vue-treeselect__option--highlight {
  background-color: #f8f9fa;
}

::v-deep .vue-treeselect__option--new {
  font-style: italic;
  color: #007bff;
}
</style> 